import { Box, styled } from '@mui/material'
import { unifiedColors } from 'styles/colors'

export const Puller = styled('div')`
  width: 40px;
  height: 4px;
  background-color: ${unifiedColors.surface.tertiary};
  border-radius: 12px;
  margin: 8px;
`

export const EventsDrawerHeader = styled(Box)`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: -55px;
  height: 56px;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  visibility: visible;
  right: 0;
  left: 0;
  background-color: ${unifiedColors.surface.subdued};
  border: 4px solid ${unifiedColors.border.accent};
  border-bottom: none;
  margin: 0 -4px;
`

export const StatsContainer = styled(Box)`
  & h2 {
    font-size: 19px;
  }
`

export const EventsDrawerContent = styled(Box)`
  height: 100vh;
  overflow-y: auto;
`
